import { useSelector } from 'react-redux';

export function useIsBusy() {
    return useSelector((state) => !!state.ui.pendingTasks);
}
